import InlineTextInput from '@/components/ui/inline-text-input';
import { pdkAxios } from '@/lib/pdk-axios';
import type { Trade } from '@/models/types';
import { tradesStore } from '@/stores/trades-store';
import { useMutation } from '@tanstack/react-query';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

const TradeVehicleMakeEditor = ({
  tradeId,
  initialMake,
}: {
  tradeId: Trade['id'];
  initialMake: string;
}) => {
  const [make, setMake] = useState(initialMake);

  const updateMakeMutation = useMutation({
    onMutate: async ({ make }: { make: string }) => {
      tradesStore.updateTrade(tradeId, {
        make: make,
      });
    },
    mutationFn: async ({ make }: { make: string }) => {
      const response = await pdkAxios.post(
        `/trades/${tradeId}/make`,
        // /api/trades/:trade_id/make
        {
          make,
        },
      );

      return response.data;
    },
    onSuccess: () => {},
    onError: (error, variables) => {
      console.error('Error updating make', error, variables);
      // TODO: handle error by adding the original cdkId back to the store
    },
  });

  const handleMakeChange = useCallback(
    debounce((newMake: string) => {
      updateMakeMutation.mutate({ make: newMake });
    }, 1000),
    [],
  );

  useEffect(() => {
    if (make === initialMake) return;

    handleMakeChange(make);
  }, [make]);

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setMake(e.target.value);
  }, []);

  useEffect(() => {
    setMake(initialMake);
  }, [initialMake]);

  return (
    <div className="flex flex-row gap-1 items-center justify-between">
      <div className="flex flex-row gap-1 items-center">
        <div className="text-sm text-gray-500 dark:text-white">Make</div>
      </div>
      <InlineTextInput
        value={make}
        onChange={onChange}
        placeholder="Enter make"
        className="text-right"
        wrapperClassName="gap-1"
      />
    </div>
  );
};

export default TradeVehicleMakeEditor;
